import { createUseStyles } from 'react-jss'

export default createUseStyles({
  selectedOptionsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 8,
    columnGap: 8,
    paddingBottom: 16
  },
  selectedItem: {
    margin: '0 !important'
  }
})
